import React from 'react';
import { Route, Routes } from 'react-router-dom';

import DefaultPage from './pages/DefaultPage/DefaultPage';
import FortifyPage from './pages/FortifyPage/FortifyPage';
import DatastatePage from './pages/DatastatePage/DatastatePage';
import ProptechServicesPage from './pages/ProptechServicesPage/ProptechServicesPage';
import MarketPage from './pages/MarketPlacePage/MarketPlacePage';
import Parkedge from './pages/MarketPlacePage/MarketProjects/Park_edge/Parke-edge';
import ErrorPage from './pages/404Page/404Page';
import ReitsPage from './pages/ReitsPage/ReitsPage';
// import StzaPage from './pages/StzaPage/StzaPage';

const routes = (
    <Routes>
        <Route path="/" element={<DefaultPage />} />
        <Route path="/projects" element={<MarketPage />} />
        <Route path="/projects/emaar-parkedge" element={<Parkedge />} />
        <Route path="/products/fortify" index element={<FortifyPage />} />
        <Route path="/products/datastate.ai" element={<DatastatePage />} />
        <Route path="/proptech/services" element={<ProptechServicesPage />} />
        <Route path="/reits" element={<ReitsPage />} />
        {/* <Route path="/stza" element={<StzaPage />} />  */}
        <Route path="/*" element={<ErrorPage />} />
    </Routes>
);

export default routes;